import { useLocation } from 'react-router-dom';

import { ResetPasswordRequestForm } from 'src/Components/Forms/ResetPasswordRequestForm';
import { FullScreenFormWrapper } from 'src/Containers/FullScreenFormWrapper';

import ChangePasswordWithToken from '../../../Components/Forms/ChangePasswordWithToken/ChangePasswordWithToken.component';

const ResetPasswordPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  return (
    <FullScreenFormWrapper maxWidth={400}>
      {token ? <ChangePasswordWithToken token={token} /> : <ResetPasswordRequestForm />}
    </FullScreenFormWrapper>
  );
};

export default ResetPasswordPage;
